import { format } from 'date-fns';

export const LAST_ORDER = {
    order_num: '',
    summary: {
        discount: 0,
        promos_discount: 0,
        subtotal: 0,
        total: 0
    },
    coupon: {
        name: '',
        description: '',
        _class: '',
        use_method: '',
        discount: {
            type: '',
            _value: ''
        }
    },
    address: {
        name: '',
        lastname: '',
        tel: '',
        street: '',
        ext_num: '',
        int_num: '',
        postalcode: '',
        colony: '',
        city: '',
        state: ''
    },
    payment: {
        available: false, // permitir elegir método de pago
        method: '',
        status: '',
        nefro_reference: '',
        mercadopago: {
            generate: false,
            message: '',
            external_resource_url: '',
            payment_url: ''
        },
        openpay: {
            generate: false,
            message: '',
            payment_url: ''
        }
    },
    products: [],
    shipping: {
        partner: '', cost: 0,
        esp_status: '',
        shippingStep: '',
        est_delivery_date: ''
    },
    account_id: '',
    order_date: ''
};

export const CHECKOUT_ORDER = {
    _id: '',
    order_num: '',
    order_date: `${format(new Date(), 'dd/MM/yyyy')}`,
    products: [],
    summary: {
        discount: 0,
        promos_discount: 0,
        subtotal: 0,
        total: 0
    },
    coupon: {
        name: '',
        text: ''
    },
    address: {
        name: '',
        lastname: '',
        email: '',
        tel: '',
        street: '',
        ext_num: '',
        int_num: '',
        postalcode: '',
        colony: '',
        city: '',
        state: '',
        crossing_streets: '',
        references: '',
        residence_type: ''
    },
    billing: {
        req_invoice: false,
        data: {
            business_name: '',
            rfc: '',
            cif: '',
            tax_system: '',
            cfdi: '',
            b_tel: '',
            b_address: '',
            b_postalcode: '',
            b_colony: '',
            b_city: '',
            b_state: ''
        }
    },
    shipping: {
        partner: '',
        cost: 0,
        odoo_id: 0
    },
    payment: {
        method: '',
        status: '',
        text: '',
        mercargopago: {
            external_resource_url: '',
            generate: false,
            message: '',
            payment_url: ''
        },
        paypal: {
            generate: false,
            message: '',
            payment_url: ''
        },
        openpay: {
            generate: false,
            message: '',
            payment_url: ''
        }
    }
};